/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class SsoProcessesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Redirect users to their SAMLv2 SSO service
   * @param ssoUuid sso profile unique identifier
   * @param email email of the person trying to authenticate. Must match the return name_id of the SAMLResponse
   * @param state optional state payload to send and return as is
   * @param redirectTo URL to redirect to after successful authentication. Will be included in SAML relay state and forwarded back after authentication.
   * @returns void
   * @throws ApiError
   */
  public getApiServicesecurityProcessesSsoSaml(
    ssoUuid: string,
    email?: string,
    state?: string,
    redirectTo?: string,
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/processes/sso/{ssoUuid}/saml',
      path: {
        'ssoUuid': ssoUuid,
      },
      query: {
        'email': email,
        'state': state,
        'redirectTo': redirectTo,
      },
      errors: {
        301: `SSO auth redirect`,
      },
    });
  }

  /**
   * Assertion endpoint for SAMLv2 responses
   * Receive and handle SAMLv2 responses
   * @param ssoUuid sso profile unique identifier
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public postApiServicesecurityProcessesSsoSamlAssert(
    ssoUuid: string,
    requestBody?: {
      /**
       * XML encoded SAML response data
       */
      SAMLResponse: string;
      /**
       * SAML Relay State
       */
      RelayState: string;
    },
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/sso/{ssoUuid}/saml/assert',
      path: {
        'ssoUuid': ssoUuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        301: `Redirect to target URL`,
      },
    });
  }

  /**
   * SAML Metadata endpoint
   * Fetch the SAML SP metadata for the given organization. Can be completely public
   * @param ssoUuid sso profile unique identifier
   * @returns any SAML SP Metadata for the given sso profile
   * @throws ApiError
   */
  public getApiServicesecurityProcessesSsoSamlMetadata(
    ssoUuid: string,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/processes/sso/{ssoUuid}/saml/metadata',
      path: {
        'ssoUuid': ssoUuid,
      },
    });
  }

  /**
   * Get the SSO options for a given worker by slug
   * Workers authenticating from the portal can be submitted to SSO auth. Can be completely public
   * @param workerSlug worker slug
   * @returns any SSO settings for the worker
   * @throws ApiError
   */
  public getApiServicesecurityProcessesWorkersSso(
    workerSlug: string,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/processes/workers/{workerSlug}/sso',
      path: {
        'workerSlug': workerSlug,
      },
    });
  }

}
